import React, { Fragment, useEffect, useState } from 'react'
import Modal from '@material-ui/core/Modal'
import Button from '@material-ui/core/Button'
import CloseIcon from '@material-ui/icons/Close';
import CheckIcon from '@material-ui/icons/Check';
import Spinner from '../../../presentation/spinner'
import { useDropZoneState, useDropZoneDispatch } from '../../../contexts/drop-zone-context'
import './style.css'


/*
    On upload files should be a file in the format async (file) => void
 */
const UploadModal = ({ onUploadFile }) => {
    const { showUploadModal, file, isLoading, isUploadCompleted } = useDropZoneState()
    const { closeModal, uploadingFile, uploadCompleted } = useDropZoneDispatch()
    const [ hasInvalidName, setHasInvalidName ] = useState(false)

    useEffect(() => {
        if (file && !isFileNameValid(file.name)) {
            setHasInvalidName(true)
        } else {
            setHasInvalidName(false)
        }
    }, [file])

    const startUpload = async (file) => {
        try{
            uploadingFile()

            await onUploadFile(file)

            uploadCompleted()
        }catch(err){
            console.error(`An error occurred uploading the file`, err)
        }
    }

    const isFileNameValid = (filename) => {
        // Verifies if file contain the accepted characters by AWS S3
        // https://docs.aws.amazon.com/AmazonS3/latest/dev/UsingMetadata.html
        const rgx = new RegExp(/^[A-Za-z0-9_.*\'\-\!\(\) ]*$/)
        return rgx.test(filename)
    }

    const StartUploadContent = () => (
        <Fragment>
            <h5>{file.name}</h5>
            <Button 
                variant="contained" 
                color="primary" 
                disableElevation
                onClick={() => startUpload(file)}
            >
                Start Upload
            </Button>
        </Fragment>
    )

    const UploadCompleted = () => (
        <Fragment>
            <CheckIcon style={{ fontSize: 70, color: '#38B690' }} />
            <h5>Your file has been successfully uploaded</h5>
        </Fragment>
    )

    const InvalidFileName = () => (
        <Fragment>
            <CloseIcon style={{ fontSize: 70, color: '#f0235b' }} />
            <h5>Invalid file name. It can only contains Alphanumeric values and/or any these characters: </h5>
            <pre>!-_.*'()</pre>
        </Fragment>
    )

    const renderModalContent = () => {
        if (isLoading) return  <Spinner /> 
        if (hasInvalidName) return <InvalidFileName />
        if (isUploadCompleted) return <UploadCompleted /> 
        return <StartUploadContent />
    }

    return (
        <Modal
            open={showUploadModal}
            onClose={closeModal}
        >
            <div className="upload-modal-wrapper">
                <div style={{display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: '1rem'}}>
                    <h6 className="title">UPLOADING FILE</h6>
                    <CloseIcon onClick={closeModal}/>
                </div>
                <div className="progress-wrapper">
                    { renderModalContent() }
                </div>
            </div>
        </Modal>
    )
}

export default UploadModal